import { reducer as identityReducer } from '@/store/Identity'
import { reducer as localizeReducer } from '../store/Localize'
import { reducer as menuReducer } from '@/store/Menu'
import { reducer as helpReducer } from '@/store/Help'
import { reducer as backgroundJobs } from '@/store/backgroundJobs'
import { reducer as blockUiReducer } from '@/store/BlockUI'
import { reducer as dialogsReducer } from '@/store/Dialogs'
import { reducer as cacheReducer } from '@/store/Cache'
import { reducer as formsReducer } from '@/store/Forms'
import { reducer as permissionReducer } from '@/store/Permissions'
import { reducer as notificationReducer } from '@/store/Notifications'
import { reducer as fileServiceReducer } from '@/store/FileService'
import { reducer as messagesReducer } from '@/store/Messages'
import { reducer as reportSubmissionGroupReducer } from '@/store/ReportSubmissionGroup'
import { reducer as reportSubmissionGroupCommentsReducer } from '@/store/ReportSubmissionGroupComments'
import { reducer as reportSubmissionsReducer } from '@/store/ReportSubmissions'
import { reducer as reportSubmissionCommentsReducer } from '@/store/ReportSubmissionComments'
import { reducer as documentationViewerReducer } from '@/store/DocumentationViewer'
import { reducer as usersManagementReducer } from '@/store/usersManagement'
import { reducer as dashboardReducer } from '@/store/Dashboard'
import { reducer as announcementsReducer } from '@/store/announcements'
import { reducer as passwordReducer } from '@/store/Password'
import { reducer as rsaKeysReducer } from '@/store/RsaKeys'
import { reducer as personalAccessTokensReducer } from '@/store/PersonalAccessTokens'
import { reducer as notificationConfigurationsReducer } from '@/store/notificationConfigurations'
import { reducer as phoneNumberReducer } from '@/store/phoneNumber'
import { reducer as twoFactorAuthReducer } from '@/store/twoFactorAuth'
import { reducer as languageSettingsReducer } from '@/store/languageSettings'
import { reducer as userLegacyCodeReducer } from '@/store/userLegacyCode'

export default {
  dialogs: dialogsReducer,
  cache: cacheReducer,
  forms: formsReducer,
  permissions: permissionReducer,
  identity: identityReducer,
  localization: localizeReducer,
  menu: menuReducer,
  help: helpReducer,
  backgroundJobs,
  blockUI: blockUiReducer,
  notifications: notificationReducer,
  fileService: fileServiceReducer,
  messages: messagesReducer,
  reportSubmissionGroup: reportSubmissionGroupReducer,
  reportSubmissionGroupComments: reportSubmissionGroupCommentsReducer,
  reportSubmissions: reportSubmissionsReducer,
  reportSubmissionComments: reportSubmissionCommentsReducer,
  documentationViewer: documentationViewerReducer,
  usersManagement: usersManagementReducer,
  dashboard: dashboardReducer,
  announcements: announcementsReducer,
  password: passwordReducer,
  rsaKeys: rsaKeysReducer,
  personalAccessTokens: personalAccessTokensReducer,
  notificationConfigurations: notificationConfigurationsReducer,
  phoneNumber: phoneNumberReducer,
  twoFactorAuth: twoFactorAuthReducer,
  languageSettings: languageSettingsReducer,
  userLegacyCode: userLegacyCodeReducer
}



// WEBPACK FOOTER //
// ./src/report-app/reducers.js